import { useMemo } from "react";
import { CroppingSuitabilityReportModel } from "@agroyaar/sdk";
import ColumnChart from "@/shared/components/charts/ColumnChart";
import Title from "@/shared/components/report-template/presentation/components/common/Title";
import ReportTemplate from "@/shared/components/report-template/presentation/components/ReportTemplate";
import Description from "@/shared/components/report-template/presentation/components/common/Description";
import {
  mapIndexToChartData,
  reportChartConfigs,
} from "@/features/reports/presentation/components/cropping-suitability-multi-product/utils/make-chart-data";

interface LandSuitabilityIndexForParametersProps {
  croppingSuitabilityReports: CroppingSuitabilityReportModel[];
}

const LandSuitabilityIndexForParameters = ({
  croppingSuitabilityReports,
}: LandSuitabilityIndexForParametersProps) => {
  const perPage = 4;
  const reportChartConfigsPage = useMemo(
    () => reportChartConfigs && Math.ceil(reportChartConfigs?.length / perPage),
    []
  );

  return (
    <>
      {Array.from({ length: reportChartConfigsPage }, (_, index) => {
        const start = index * perPage;
        const pages = reportChartConfigs.slice(start, start + perPage);
        return (
          <ReportTemplate
            serviceType="CROPPING_SUITABILITY"
            pageNumber={4 + index}
          >
            <div className="w-full flex flex-col gap-6">
              {index === 0 && (
                <>
                  <Title> شاخص تناسب زمین برای پارامترهای مختلف </Title>
                  <Description>
                    برای هر محصول، تناسب پارامترهای کلیدی شامل دما، بارندگی،
                    درجه روز رشد، هدایت الکتریکی، pH، بافت، کربن آلی، شیب زمین،
                    عمق خاک و شاخص تامین نیاز آبی بررسی شده است. نتایج تناسب هر
                    پارامتر در نمودارهای زیر مشخص شده است.
                  </Description>
                </>
              )}

              <div className=" w-full flex flex-col justify-center items-center">
                <div className="w-full grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-y-5 my-2">
                  {pages.map(({ key, label, yAxisTitle }) => (
                    <ColumnChart
                      key={key}
                      data={mapIndexToChartData(
                        croppingSuitabilityReports,
                        key
                      )}
                      height={320}
                      title={label}
                      titleFontSize="12px"
                      labelsFontSize="10px"
                      yAxisTitle={yAxisTitle ?? "مقدار"}
                      decimalNumber={2}
                    />
                  ))}
                </div>
                {index + 1 === reportChartConfigsPage && (
                  <div className=" w-full flex flex-col justify-center items-center mt-8">
                    <Title>
                      مقایسه تناسب زمین برای محصولات از لحاظ پارامترهای مختلف
                    </Title>
                  </div>
                )}
              </div>
            </div>
          </ReportTemplate>
        );
      })}
    </>
  );
};

export default LandSuitabilityIndexForParameters;
